import { IEntityPanelWidthSetAction } from './types';
import { AT_ENTITY_PANEL_WIDTH_SET } from './constants';

export const entityPanelWidthSetAction = (
    entityPanelWidth: number
): IEntityPanelWidthSetAction => ({
    type: AT_ENTITY_PANEL_WIDTH_SET,
    entityPanelWidth
});
